import React from 'react'
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import type { FAQItem } from '@/data/research/types'

interface FAQAccordionProps {
  items: FAQItem[]
  sectionHeading?: string
}

const FAQAccordion: React.FC<FAQAccordionProps> = ({
  items,
  sectionHeading = 'Frequently Asked Questions',
}) => {
  return (
    <Box component="section" sx={{ my: 4 }}>
      <Typography
        variant="h2"
        sx={{ mb: 3, fontSize: { xs: '1.35rem', md: '2.5rem' } }}
      >
        {sectionHeading}
      </Typography>
      {items.map((item, index) => (
        <Accordion key={index} disableGutters elevation={0} variant="outlined">
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls={`faq-panel-${index}-content`}
            id={`faq-panel-${index}-header`}
          >
            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
              {item.question}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
              {item.answer}
            </Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  )
}

export default FAQAccordion
